export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4854.bad45e4f.jpg";